import { StorefrontModule } from "@lib/appRegister";
import { OrderStore } from "./store";

export const OrderModule: StorefrontModule = function ({ store }) {
  store.registerModule("order", OrderStore);
  store.dispatch("order/init");
};
